import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import Props from './components/props.js';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "props"
    }}>{`Props`}</h1>
    <Props mdxType="Props" />
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <h3 {...{
      "id": "example-1"
    }}>{`Example-1`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Example for the props - options , placeholder.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`options is the required prop to be passed to the Filter component.`}</p>
      </li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import React, { useState } from 'react'
import Filter from 'react-searchable-filter'
import 'react-searchable-filter/dist/index.css'

const App = () => {
  const options = [
    {
      filterBy: 'status',
      values: ['finished', 'not-finished', 'pending'],
      description: 'filter by status'
    },
    {
      filterBy: 'age',
      values: ['30', '25', '18', '22'],
      description: 'filter by age'
    },
    {
      filterBy: 'username',
      description: 'filter by username',
      values: ['John', 'Albert', 'Robert']
    }
  ]

  return (
    <div>
      <Filter options={options} placeholder='Filter Users' />
    </div>
  )
}
`}</code></pre>
    <h3 {...{
      "id": "example-2"
    }}>{`Example-2`}</h3>
    <ul>
      <li parentName="ul">{`Example for props - className, style, inputClassName, dropdownListClassName and hoverColor.`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`.filter-component {
  width:'300px'
  height:'80px'
}

`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import React, { useState } from 'react'
import Filter from 'react-searchable-filter'
import 'react-searchable-filter/dist/index.css'

import './index.css'
import options from '../path/where/options/present'

const App = () => {
  return (
    <div>
      <Filter
        options={options}
        className='filter-component'
        inputClassName='filter-field-input'
        dropdownListClassName='dropdown-list'
        style={{ margin: '10px' }}
        hoverColor='teal'
      />
    </div>
  )
}
`}</code></pre>
    <h3 {...{
      "id": "example-3"
    }}>{`Example-3`}</h3>
    <ul>
      <li parentName="ul">{`Example for the prop - onSubmit and onClear`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import React, { useState } from 'react'
import Filter, { onSubmitFiltersType } from 'react-searchable-filter'
import 'react-searchable-filter/dist/index.css'

import options from '../path/where/options/present'

const App = () => {
  const [selectedFilters, setSelectedFilters] = useState([])
  const submitHandler = (filters: onSubmitFiltersType) => {
    setSelectedFilters(filters)
  }

  const clearFilters = () => {
    setSelectedFilters([])
  }

  return (
    <div>
      <Filter
        options={options}
        onSubmit={submitHandler}
        onClear={clearFilters}
      />
    </div>
  )
}
`}</code></pre>
    <h3 {...{
      "id": "example-4"
    }}>{`Example-4`}</h3>
    <ul>
      <li parentName="ul">{`Example for the props - customFilterIcon, customClearIcon`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import React, { useState } from 'react'
import Filter from 'react-searchable-filter'
import 'react-searchable-filter/dist/index.css'
import { FaFilter } from 'react-icons/fa'
import { AiFillCloseCircle } from 'react-icons/ai'

import options from '../path/where/options/present'

const App = () => {
  return (
    <div>
      <Filter
        options={options}
        customFilterIcon={<FaFilter />}
        customClearIcon={<AiFillCloseCircle />}
      />
    </div>
  )
}
`}</code></pre>
    <h3 {...{
      "id": "example-5"
    }}>{`Example-5`}</h3>
    <ul>
      <li parentName="ul">{`Example for the prop - editable and optionsListMaxHeight`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import React, { useState } from 'react'
import Filter from 'react-searchable-filter'
import 'react-searchable-filter/dist/index.css'

import options from '../path/where/options/present'

const App = () => {
  return (
    <div>
      <Filter options={options} editable={false} optionsMaxHeight={300} />
    </div>
  )
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      